import React, { FC, useEffect } from 'react';

const FileDownload: FC<{ downloadFn: () => void }> = ({ downloadFn }) => {
  useEffect(() => {
    downloadFn();
  }, [downloadFn]);
  return (
    <section className="flex flex-col flex-1 overflow-hidden w-full px-6 pt-10 mx-auto bg-white font-effra">
      <h2 className="font-effra text-2xl font-medium mb-4 text-gray-45">Your download will begin in a few seconds</h2>
      <p className="text-lg font-effra font-normal text-gray-25">
        If your download doesn’t start automatically,{' '}
        <button onClick={downloadFn} className="text-blue-600">
          click here to reload.
        </button>
      </p>
    </section>
  );
};

export default FileDownload;
